import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface CircularLoadingProps {
  label?: string;
  className?: string;
  /** Fills the parent and dims content behind the spinner. */
  overlay?: boolean;
  size?: "sm" | "md" | "lg";
}

const SIZE_CLASS = {
  sm: "size-4",
  md: "size-8",
  lg: "size-10",
} as const;

/**
 * Circular indeterminate spinner used while search/filter requests are in flight.
 */
export function CircularLoading({
  label = "Loading…",
  className,
  overlay = false,
  size = "md",
}: CircularLoadingProps) {
  const spinner = (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn("flex flex-col items-center justify-center gap-2 text-muted-foreground", className)}
    >
      <Loader2 className={cn(SIZE_CLASS[size], "animate-spin text-primary")} aria-hidden="true" />
      <span className="text-sm font-medium">{label}</span>
    </div>
  );

  if (!overlay) return spinner;

  return (
    <div className="absolute inset-0 z-20 flex min-h-[16rem] items-center justify-center bg-background/70 backdrop-blur-[1px]">
      {spinner}
    </div>
  );
}
